import { mapGetters } from 'vuex'
import { BModal } from 'bootstrap-vue'

export default {
  name: 'b-modal-custom',

  extends: BModal,

  computed: {
    ...mapGetters('gui', [
      // modal dialogs aren't attached to "div.c-app",
      // so we need to specify dark-theme to dialog
      'themeClass',
    ]),
  },

  watch: {
    themeClass: {
      immediate: true,
      handler: function (className) {
        this.$emit('update:modalClass', className);
      },
    },
  },
};
